import React, { useEffect, useState } from "react";
import AddMenuItemView from "./AddMenuItemView";
import ProductCard from "./ProductCard";

import { PlusThinWhiteIcon, FilterIcon } from "../../../assets/icons";
import { SubcategorySelectDTO } from "../../../models/subcategories/subcategories.response";
import { useParams } from "react-router-dom";
import { subcategoryService } from "../../../services/subcategoriesService";
import { useNotification } from "../../toster-notification/NotificationContext";
import { productService } from "../../../services/productService";
import { ProductSettingsListItemDTO } from "../../../models/product/product.response";
import EditMenuItemView from "./EditMenuItemView";
import { confirmDialog } from "../../../utils/confirmDialog";
import { useStepContext } from "@mui/material";

const MenuItemsPage: React.FC = () => {

    const [isAddMenuItemViewOpen, setIsAddMenuItemViewOpen] = useState(false);
    const [isEditMenuItemViewOpen, setIsEditMenuItemViewOpen] = useState(false);

    const [selectedSubcategoryId, setSelectedSubcategoryId] = useState<string>("");
    const [selectedProductId, setSelectedProductId] = useState<string>("");
    const [serachFilter, setSearchFilter] = useState<string>("");

    const [subcategories, setSubcategories] = useState<SubcategorySelectDTO[]>([]);
    const [products, setProducts] = useState<ProductSettingsListItemDTO[]>([]);

    const [loading, setLoading] = useState(false);

    const { localId } = useParams<{ localId: string }>();

    const { notify } = useNotification();

    useEffect(() => {
        fetchSubcategories();
        fetchProducts();
    }, [localId]);


    const fetchProducts = async () => {
        if (!localId) return;

        setLoading(true);
        try {
            const response = await productService.getProductsByLocalId(localId);

            if (response.success && response.data) {
                setProducts(response.data);
            } else {
                notify("error", response.message || "Došlo je do greške prilikom učitavanja proizvoda.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom učitavanja proizvoda.");
        } finally {
            setLoading(false);
        }
    };

    const fetchSubcategories = async () => {
        if (!localId) return;

        setLoading(true);
        try {
            const response = await subcategoryService.getSubcategoriesSelect(localId);

            if (response.success && response.data) {
                setSubcategories(response.data);
            } else {
                notify("error", response.message || "Došlo je do greške prilikom učitavanja podkategorija.");
            }

        } catch (error) {
            notify("error", "Došlo je do greške prilikom učitavanja podkategorija.");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteProduct = async (productId: string) => {
        if(!localId) {
            notify("error", "ID lokala nije pronađen.");
            return;
        }

        let confirmDelete = await confirmDialog({
            title: "Potvrda brisanja",
            description: "Da li ste sigurni da želite da obrišete ovaj proizvod? Ova akcija je nepovratna.",
            isDelete: true
        })

        if (!confirmDelete) {
            return;
        }

        setLoading(true);

        try {
            const response = await productService.deleteProductById(localId, productId);

            if (response.success) {
                notify("success", "Proizvod je uspešno obrisan.");
                fetchProducts();
            } else {
                notify("error", response.message || "Došlo je do greške prilikom brisanja proizvoda.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom brisanja proizvoda.");
        } finally {
            setLoading(false);
        }
    };

    if (localId === undefined) {
        return <div>Local ID is missing.</div>;
    }

    return (
        <>

            {isAddMenuItemViewOpen &&
                <AddMenuItemView
                    onClose={() => {
                        setIsAddMenuItemViewOpen(false);
                        fetchProducts();
                    }}
                />
            }

            {isEditMenuItemViewOpen &&
                <EditMenuItemView
                    productId={selectedProductId}
                    onClose={() => {
                        setIsEditMenuItemViewOpen(false)
                        fetchProducts();
                    }}
                />
            }

            <section className="item-section">
                <div className="w-layout-blockcontainer container item w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Stavke menija</h2>
                                <div className="text-block">
                                    Upravljajte svim proizvodima u meniju<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddMenuItemViewOpen(true)}>
                                    <img loading="lazy" src={PlusThinWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Nova stavka</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div item-list-block">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Sve stavke</div>
                                    <div className="list-header-description">
                                        Ukupno stavki: {products.length} ({products.filter(p => !p.isDeleted).length} aktivnih)<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi stavke" type="text"
                                                value={serachFilter}
                                                onChange={(e) => setSearchFilter(e.target.value)}
                                            />
                                            <select className="form-select w-select"
                                                onChange={(e) => setSelectedSubcategoryId(e.target.value)}
                                                value={selectedSubcategoryId}
                                            >
                                                <option value="">Sve podkategorije</option>
                                                {subcategories.map((subcategory) => (
                                                    <option key={subcategory.id} value={subcategory.id}>{subcategory.name}</option>
                                                ))}
                                            </select>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="item-list-div">
                                {products
                                    .filter(
                                        p => p.subcategoriesIds.includes(selectedSubcategoryId) || selectedSubcategoryId === "" &&
                                        (p.name.toLocaleLowerCase().includes(serachFilter.toLocaleLowerCase()) || p.description.toLocaleLowerCase().includes(serachFilter.toLocaleLowerCase()))
                                    )
                                    .map((product) => (
                                        <ProductCard
                                            onDelete={() => {
                                                handleDeleteProduct(product.id)
                                                fetchProducts();
                                            }}
                                            onEdit={() => {
                                                setIsEditMenuItemViewOpen(true)
                                                setSelectedProductId(product.id);
                                            }}
                                            product={product} />
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default MenuItemsPage;